import React from 'react';
import { observer } from 'mobx-react';
import { config } from '../../config';

// Translations
import translate from '../Translate.js';

const Payments = observer(class Payments extends React.Component {
  componentWillMount() {
    this.state = {
      paymentClass: null
    }
  }

  componentDidMount() {
    //TODO: This needs to move to a settings/config file.
    const stripe = window.Stripe(config.stripeApiKey);
    const elements = stripe.elements();
    const _this = this;

    this.props.store.PaymentStore.paymentToken = {};

    // Create and card field
    const style = {
      base: {
        color: '#526069',
        fontFamily: '"Roboto", sans-serif',
        fontSize: '14px',
        lineHeight: '35px',
        '::placeholder': {
          color: '#a8bbc2'
        }
      },
      invalid: {
        color: '#e9595b'
      }
    };
    const card = elements.create('card', {style: style});
    card.mount('#payment-card');

    // Listen for errors
    const errorHolder = document.querySelector('#payment-errors');

    card.addEventListener('change', function(event) {
      if(event.error) {
        console.log(event.error);
        errorHolder.textContent = event.error.message;
      } else {
        errorHolder.textContent = '';
      }
    });

    // Submit payment
    const form = document.querySelector('#payment-form');

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if(form.className.indexOf('submitted') < 0) {
        form.className += ' submitted';

        stripe.createToken(card).then(function(result) {
          if(result.error) {
            // Let the user know there was an error
            errorHolder.textContent = result.error.message;
            form.classList.remove('submitted');
          } else {
            // Send token
            stripeTokenHandler(result.token);
          }
        });
      }
    });

    function stripeTokenHandler(token) {
      // Insert the token id into the form and submit
      const tokenInput = document.querySelector('#payment-token');
      tokenInput.value = token.id;
      // form.submit();

      _this.props.store.PaymentStore.paymentToken = token;

      _this.props.submit();
      // _this.props.store.SessionStore.submitPayment();
    }
  }

  render() {
    const { translation } = this.props;

    return (
      <div className="payment">
        <form id="payment-form" className="payment__form">
          <input id="payment-token" type="hidden" />

          <ul className="fields">
            <li>
              <label htmlFor="payment-name">
                {translation.name}
              </label>

              <input
                type="text"
                id="payment-name"
                className="_lr-hide"
                placeholder={translation.name_helper}
                autoFocus
              />
            </li>
            <li>
              <label htmlFor="payment-card">{translation.card}</label>
              <div id="payment-card" className="payment__fields inspectlet-sensitive _lr-hide"></div>
            </li>
          </ul>

          <div id="payment-errors" className="errors"></div>

          <button type="submit" className="btn">{translation.submit}</button>
        </form>
      </div>
    );
  }
})

export default translate('Payments')(Payments);



// WEBPACK FOOTER //
// ./src/app/components/Payments/Payments.js